module.exports = __webpack_public_path__ + "img/landingPage.17fb40e0.png";